import { render, staticRenderFns } from "./specialLiveManage.vue?vue&type=template&id=6c768de5&scoped=true&"
import script from "./specialLiveManage.vue?vue&type=script&lang=js&"
export * from "./specialLiveManage.vue?vue&type=script&lang=js&"
import style0 from "./specialLiveManage.vue?vue&type=style&index=0&id=6c768de5&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c768de5",
  null
  
)

export default component.exports